// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"04c104f8","94":"177c71c1","154":"a1e873d9","220":"20453c7f","308":"d7d803f8","777":"aa93a788","824":"8be78be9","916":"07829768","987":"04c104f8"}[chunkId] + ".chunk.css";
};